import clsx from "clsx";

type Props = {
  className?: string;
};
export const TagGuaranteed = ({ className }: Props) => {
  return (
    <div
      className={clsx(
        "inline-block text-xs font-semibold py-[3px] px-1.5 bg-[#16C4C4] rounded-sm text-white h-[22px]",
        className,
      )}
    >
      Départ garanti
    </div>
  );
};
